/* istanbul ignore file */
import { Badge } from 'framework/ui/mui-builder';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const ReferralCandidateBadge = (props: FieldBadgeProps) => {
  return (
    <Badge color="info" sx={{ ml: 1 }} {...props}>
      Referral
    </Badge>
  );
};

export default ReferralCandidateBadge;
